import { TbPlus } from 'react-icons/tb'
import clsx from 'clsx'
import classes from './PricingDivider.module.scss'

export const PricingDivider = () => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.divider}>
        <div className={clsx(classes.circle, classes.circle__outer)}>
          <div className={clsx(classes.circle, classes.circle__inner)}>
            <TbPlus className={classes.icon} />
          </div>
        </div>
      </div>
    </div>
  )
}
